<modal #modal>
    <div class="bank-info">
        <button type="button" class="bank-info__close" role="button" aria-label="Luk" aria-roledescription="Luk modal" (click)="closeModal()">
            <img src="../../../../../assets/icons/close-b.svg"/>
        </button>
        
        <div class="bank-info__content text-center">
            <h2 class="bank-info__heading">
                Reg nr. og konto nr.
            </h2>

            <h3 class="bank-info__subheading">Hvor finder jeg registrerings- og kontonummeret?</h3>
            
            <p>Registreringsnummeret er på 4 cifre og kontonummeret er på mellem 7 til 10 cifre.</p>

            <p>Du kan finde registreringsnummer og kontonummer på bagsiden af dit betalingskort (VISA/Dankort).</p>
            
            <p>Du kan også finde dit registrerings- og kontonummer på dit kontoudtog.</p>

            <img src="../../../../../assets/images/modals/credit-card.svg" alt="Bank info" class="bank-info__image">
        </div>


    </div>
</modal>